import React, { useState, useEffect } from 'react';
import api from '../api';
import { useAuth } from '../AuthContext';
import { Plus, Edit2, FolderOpen } from 'lucide-react';

const Projects = () => {
  const { isAdmin } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editProject, setEditProject] = useState(null);
  const [form, setForm] = useState({ name: '', description: '', is_active: true });

  const fetchProjects = async () => {
    try {
      const res = await api.get('/projects?active=false');
      setProjects(res.data);
    } catch (error) {
      console.error('Fehler:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchProjects(); }, []);

  const openModal = (project = null) => {
    if (project) {
      setEditProject(project);
      setForm({ name: project.name, description: project.description || '', is_active: project.is_active });
    } else {
      setEditProject(null);
      setForm({ name: '', description: '', is_active: true });
    }
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editProject) {
        await api.put(`/projects/${editProject.id}`, form);
      } else {
        await api.post('/projects', form);
      }
      setShowModal(false);
      fetchProjects();
    } catch (error) {
      alert(error.response?.data?.error || 'Fehler beim Speichern.');
    }
  };

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Laden...</div>;

  return (
    <div>
      <div className="page-header">
        <div className="page-header-actions">
          <div>
            <h2>Projekte</h2>
            <p>Übersicht aller Projekte</p>
          </div>
          {isAdmin && (
            <button className="btn btn-primary" onClick={() => openModal()}>
              <Plus size={16} /> Neues Projekt
            </button>
          )}
        </div>
      </div>

      <div className="card">
        <div className="table-container">
          {projects.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Beschreibung</th>
                  <th>Status</th>
                  <th>Erstellt am</th>
                  {isAdmin && <th>Aktionen</th>}
                </tr>
              </thead>
              <tbody>
                {projects.map((project) => (
                  <tr key={project.id}>
                    <td><strong>{project.name}</strong></td>
                    <td>{project.description || '-'}</td>
                    <td>
                      <span className={`badge badge-${project.is_active ? 'active' : 'inactive'}`}>
                        {project.is_active ? 'Aktiv' : 'Inaktiv'}
                      </span>
                    </td>
                    <td>{new Date(project.created_at).toLocaleDateString('de-DE')}</td>
                    {isAdmin && (
                      <td>
                        <button className="btn btn-secondary btn-sm btn-icon" onClick={() => openModal(project)} title="Bearbeiten">
                          <Edit2 size={14} />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="empty-state">
              <FolderOpen size={40} />
              <p>Keine Projekte vorhanden.</p>
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editProject ? 'Projekt bearbeiten' : 'Neues Projekt'}</h3>
              <button className="btn btn-secondary btn-sm" onClick={() => setShowModal(false)}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Projektname</label>
                  <input type="text" className="form-control" value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })} required />
                </div>
                <div className="form-group">
                  <label>Beschreibung</label>
                  <textarea className="form-control" value={form.description}
                    onChange={(e) => setForm({ ...form, description: e.target.value })} />
                </div>
                {editProject && (
                  <div className="form-group">
                    <label>
                      <input type="checkbox" checked={form.is_active}
                        onChange={(e) => setForm({ ...form, is_active: e.target.checked })}
                        style={{ marginRight: 8 }} />
                      Projekt aktiv
                    </label>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Abbrechen</button>
                <button type="submit" className="btn btn-primary">{editProject ? 'Speichern' : 'Erstellen'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Projects;
